import Menu from 'components/Menu';
import React, { useEffect } from 'react';
import { Router } from 'next/router';
import { GetStaticProps } from 'next';
import { motion } from 'framer-motion';

import Head from 'u9/components/Head';

import { AboutPageType } from 'types/aboutPage';
import { MenuItemsType } from 'types/menuItems';
import { BlogPageType } from 'types/blogPage';
import { CommonsType } from 'types/commons';

import { IndexPageProps } from 'containers/LandingPage';
import Blog from 'components/Blog';

import {
  aboutPageQuery,
  commonsQuery,
  indexQuery,
  menuQuery,
  newsPageQuery,
} from 'utils/gql';
import { cmsApiClient } from 'utils/api/cms';
import { ACTIONS, CATEGORIES, LABEL, Tracking } from 'utils/tracking';

export const getStaticProps: GetStaticProps = async context =>
  Promise.all([
    cmsApiClient.query({ query: indexQuery(context.locale) }),
    cmsApiClient.query({ query: aboutPageQuery(context.locale) }),
    cmsApiClient.query({ query: menuQuery(context.locale) }),
    cmsApiClient.query({ query: newsPageQuery(context.locale) }),
    cmsApiClient.query({ query: commonsQuery(context.locale) }),
  ]).then(
    ([
      pageResults,
      aboutPageResult,
      menuResult,
      newsPageResult,
      commonResult,
    ]) => ({
      props: {
        page: pageResults.data.indexPages[0],
        aboutPage: aboutPageResult.data.aboutPages[0],
        menu: menuResult.data.menuItems[0],
        newsPage: newsPageResult.data.newsPages[0],
        commons: commonResult.data.commons[0],
      },
    })
  );

export type NewsPageProps = {
  page: IndexPageProps;
  aboutPage: AboutPageType;
  router: Router;
  menu: MenuItemsType;
  newsPage: BlogPageType;
  commons: CommonsType;
};

const NewsPage = ({
  page,
  router,
  menu,
  newsPage,
  commons,
}: NewsPageProps): JSX.Element => {
  const lang = router.locale;
  const headProps = { ...page.head, lang };

  useEffect(() => {
    Tracking.event({
      category: CATEGORIES.PageNews,
      action: ACTIONS.PageNews,
      label: LABEL.PageNews,
    });
  }, []);

  return (
    <motion.div>
      <Head {...headProps} />
      <Menu light items={menu.items} />
      <Blog
        background={newsPage.background}
        backgroundMobile={newsPage.backgroundMobile}
        content={newsPage.posts}
        commons={commons}
        heading={newsPage.name}
      />
    </motion.div>
  );
};

export default NewsPage;
